export default "__VITE_ASSET__7bdb9050__"